import bemCssModules from 'bem-css-modules';
import type { VFC } from 'react';
import { useState } from 'react';
import { useAsyncEffect } from 'use-async-effect';

import MostCommonQuestionsModuleCss from './MostCommonQuestions.module.css';
import { LocalizedText } from '~/components/LocalizedText/LocalizedText';
import { QuestionList } from '~/components/QuestionList/QuestionList';
import { LocalizationItem, MOST_COMMON_ITEM_MAX_AMOUNT_LINES } from '~/constants';
import { useMostCommonQuestionsStore } from '~/stores';

const block = bemCssModules(MostCommonQuestionsModuleCss);

export const MostCommonQuestions: VFC = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const { mostCommonQuestions, loadMostCommonQuestions, networkError } =
    useMostCommonQuestionsStore();

  useAsyncEffect(async () => {
    await loadMostCommonQuestions();
    setIsLoaded(true);
  }, []);

  if (!isLoaded || networkError || !mostCommonQuestions.Questions.length) {
    return null;
  }

  return (
    <div className={block()}>
      <div className={block('inner')}>
        <h1 className={block('title')}>
          <LocalizedText localizationItem={LocalizationItem.MostCommonQuestions} />
        </h1>
        <QuestionList
          questionList={mostCommonQuestions.Questions}
          isShowMoreEnabled={false}
          truncate={MOST_COMMON_ITEM_MAX_AMOUNT_LINES}
        />
      </div>
    </div>
  );
};
